import { useState } from "react";

import {
  ModalSubFeedbackContentNegativeBlockSub,
  ModalSubFeedbackContentNegativeComments,
  ModalSubFeedbackContentNegativeReasons,
  ModalSubFeedbackContentNegativeSummary,
  NegativeData,
  Step,
} from "~components/ModalSubFeedback";

type ModalSubFeedbackContentNegativeProps = {
  negativeData: NegativeData;
  onDismiss: () => void;
  onSubmit: (data: NegativeData) => void;
  setNegativeData: (negativeData: NegativeData) => void;
  setStep: (step: Step) => void;
  subName?: string;
  schoolName: string;
  hasSubmissionError?: boolean;
};

export type NegativeStep = "block" | "reasons" | "comments" | "summary";

export function ModalSubFeedbackContentNegative(props: ModalSubFeedbackContentNegativeProps) {
  const {
    negativeData,
    onDismiss,
    setNegativeData,
    setStep,
    subName,
    schoolName,
    onSubmit,
    hasSubmissionError,
  } = props;

  const [negativeStep, setNegativeStep] = useState<NegativeStep>("block");

  return (
    <>
      {negativeStep === "block" && (
        <ModalSubFeedbackContentNegativeBlockSub
          goBackToRatingStep={() => setStep("rating")}
          negativeData={negativeData}
          onDismiss={onDismiss}
          setNegativeData={setNegativeData}
          setNegativeStep={setNegativeStep}
          subName={subName}
          schoolName={schoolName}
        />
      )}
      {negativeStep === "reasons" && (
        <ModalSubFeedbackContentNegativeReasons
          negativeData={negativeData}
          onDismiss={onDismiss}
          setNegativeData={setNegativeData}
          setNegativeStep={setNegativeStep}
        />
      )}
      {negativeStep === "comments" && (
        <ModalSubFeedbackContentNegativeComments
          negativeData={negativeData}
          onDismiss={onDismiss}
          setNegativeData={setNegativeData}
          setNegativeStep={setNegativeStep}
          onSubmit={onSubmit}
          subName={subName}
          hasSubmissionError={hasSubmissionError}
        />
      )}
      {negativeStep === "summary" && (
        <ModalSubFeedbackContentNegativeSummary
          negativeData={negativeData}
          onDismiss={onDismiss}
          subName={subName}
          schoolName={schoolName}
        />
      )}
    </>
  );
}
